import css from './Layout.module.scss';
import { useLogout, useUserState } from '../../../Contexts/User';
import { Login } from '../Login/Login';
import { useIsSessionValid } from '../../../Contexts/Axios';
import React, { Suspense, useEffect } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { AppType, useAppCoreState } from '../../../Contexts/AppCore';
import { GMSpinner } from '../../../CommonControls/Spinner/Spinner';
import { SupportSidebar } from '../Sidebar/SupportSidebar';
import { DashboardSidebar } from '../Sidebar/DashboardSidebar';
import { PermissionsProvider } from '../../../Contexts/Permissions/Permissions';
import { DashboardFooter } from '../../Dashboard/Footer/DashboardFooter';
const SupportRoutes = React.lazy(() => import('./SupportRoutes'));
const DashboardRoutes = React.lazy(() => import('./DashboardRoutes'));

export const Layout: React.FC = () => {
    const { LoggedIn } = useUserState();
    const { RunningAppType } = useAppCoreState();
    const isSessionValid = useIsSessionValid();
    const logout = useLogout();

    useEffect(() => {
        if (!isSessionValid && LoggedIn) {
            logout(true);
        }
    }, [isSessionValid, LoggedIn, logout]);


    return (
        <div className={css.root}>
            {!LoggedIn ?
                <Login />
                :
                <IdleTimerProvider
                    timeout={RunningAppType === AppType.Support ? 64800000 : 7200000}
                    stopOnIdle
                    onIdle={() => logout(true)}
                    eventsThrottle={5000}
                >
                    <div className={css.sidebar}>
                        {RunningAppType === AppType.Support ? <SupportSidebar /> : <DashboardSidebar />}
                    </div>
                    <div className={css.contentArea}>
                        <Suspense
                            // TODO use dummy screen with skeletons?
                            fallback={
                                <div className={css.fallback}>
                                    <GMSpinner />
                                </div>
                            }
                        >
                            {RunningAppType === AppType.Support ? (
                                <SupportRoutes />
                            ) : (
                                <PermissionsProvider>
                                    <div className={css.dashboardContent}>
                                        <div className={css.dashboardRoutes}>
                                            <DashboardRoutes />
                                        </div>
                                        <DashboardFooter />
                                    </div>
                                </PermissionsProvider>
                            )}
                        </Suspense>
                    </div>
                </IdleTimerProvider>
            }
        </div>
    );
};